<script lang="ts" setup>
import type { Addon, AddonGroup } from '~/models';

const props = defineProps<{
  group: AddonGroup;
  editable: boolean;
}>();

const addons = computed<Addon[]>(() => {
  if (props.group.hideAddonsName) {
    return [];
  }
  return props.group.addons.filter((addon) =>
    !addon.composeName ||
    addon.composeName === 'Not Show' ||
    addon.quantity > 1
  );
});
</script>

<template>
  <span
    v-if="props.group.showName"
    class="pl-2"
    :class="{ 'pl-8': props.editable }"
    data-test="group-name"
  >
    {{ `--- ${props.group.name} ---` }}
  </span>

  <template
    v-for="addon of addons"
    :key="addon.uuid"
  >
    <span
      v-if="addon.quantity > 0"
      class="text-sm pl-2"
      :class="{ 'pl-8': props.editable }"
      data-test="addon-name"
    >
      <template v-if="addon.quantity > 1">
        {{ `${addon.quantity}x ${addon.name}` }}
      </template>
      <template v-else>
        {{ addon.name }}
      </template>
    </span>
  </template>
</template>
